import { useQuery } from "urql";

import {
  DeskCollectionFilter,
  DeskCollectionOrderBy,
  GetDeskCollectionsDocument,
} from "../../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../../utils/api.ts";
import { ApiHookProps } from "../../types.ts";

export const useDeskCollections = ({
  filter,
  orderBy,
  page,
  pause,
}: ApiHookProps<DeskCollectionFilter, DeskCollectionOrderBy>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({ query: GetDeskCollectionsDocument, variables, pause });
};
